// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B100, N10, N600, N800, N90 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkListTitle = styled.h5({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkListWrapper = styled.div({
  maxWidth: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemLink = styled.a({
  position: 'relative',
  margin: 0,
  overflow: 'hidden',
  display: 'block',
  paddingLeft: "var(--ds-space-100, 10px)",
  paddingRight: "var(--ds-space-100, 10px)",
  borderRadius: "var(--ds-border-radius-100, 3px)",
  '&:hover': {
    background: "var(--ds-background-neutral-subtle-hovered, ".concat(N10, ")"),
    textDecoration: 'none'
  },
  '&:focus': {
    outline: 0,
    boxShadow: "0 0 0 ".concat("var(--ds-space-025, 2px)", " ", "var(--ds-border-focused, ".concat(B100, ")"))
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemWrapper = styled.div({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemIcon = styled.img({
  borderRadius: "var(--ds-border-radius-100, 3px)",
  display: 'flex',
  flexShrink: 0,
  width: "var(--ds-space-300, 24px)",
  height: "var(--ds-space-300, 24px)",
  marginTop: "var(--ds-space-100, 8px)",
  marginBottom: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemBody = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: "var(--ds-space-200, 16px)",
  justifyContent: 'center',
  minWidth: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemTitle = styled.div({
  paddingRight: "var(--ds-space-100, 10px)",
  paddingBottom: "var(--ds-space-025, 2px)",
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  p: {
    display: 'inline-block',
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    margin: 0,
    color: "var(--ds-text, ".concat(N800, ")"),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemByline = styled.p({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtlest, ".concat(N90, ")"),
  margin: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  paddingRight: "var(--ds-space-100, 10px)",
  minWidth: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RecentWorkItemContainer = styled.span({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&:after': {
    content: "'\\00B7'",
    paddingRight: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-050, 4px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
export var RecentWorkItemDescription = styled.span({});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LinkWrapper = styled.div({
  display: 'flex',
  marginLeft: "var(--ds-space-100, 10px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  'button, a, span': {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: "var(--ds-space-0, 0px)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    height: 'unset !important'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EmptyStateTextWrapper = styled.div({
  marginTop: "var(--ds-space-200, 16px)",
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-accent-gray, ".concat(N600, ")")
});